import type { CapturedHttpRequest, CapturedHttpResponse } from '@reqshare/protocol';

export const MAX_PAYLOAD_SIZE_BYTES = 100 * 1024 * 1024; // 100MB

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, i);
  return `${value.toFixed(value < 10 ? 1 : 0)} ${units[i]}`;
}

function estimateHeadersSize(headers: Array<{ name: string; value: string }>): number {
  return headers.reduce((sum, h) => sum + h.name.length + h.value.length, 0);
}

export function calculatePayloadSize(
  request: CapturedHttpRequest,
  response?: CapturedHttpResponse,
): number {
  let size = 0;

  size += request.url.length;
  size += request.method.length;
  size += estimateHeadersSize(request.headers);
  size += estimateHeadersSize(request.queryString);
  if (request.body?.text) size += request.body.text.length;

  if (response) {
    size += estimateHeadersSize(response.headers);
    if (response.body?.text) size += response.body.text.length;
  }

  return size;
}

export function calculateBatchPayloadSize(
  entries: Array<{ request: CapturedHttpRequest; response?: CapturedHttpResponse }>,
): number {
  return entries.reduce((sum, entry) => sum + calculatePayloadSize(entry.request, entry.response), 0);
}
